import React from 'react'
import PropTypes from 'prop-types'
import useAuthority from 'utils/hooks/useAuthority'

const AuthorityCheck = (props) => {
    const {
        userAuthority = [],
        userOrganization = [],
        authority = [],
        enableFuncs,
        children,
    } = props

    const userEnableFuncs =
        userOrganization.length > 0
            ? userOrganization.flatMap((item) => item.enable_funcs)
            : []

    const enableFuncMatched = useAuthority(userEnableFuncs, enableFuncs)

    const roleMatched = useAuthority(userAuthority, authority)

    if (!enableFuncMatched) {
        return null
    }

    return roleMatched ? children : <></>
}

AuthorityCheck.propTypes = {
    userAuthority: PropTypes.array,
    authority: PropTypes.array,
}

export default AuthorityCheck
